export default __webpack_public_path__ + "static/media/tete72.bc213214.png";